import React from "react";
import KickImage from 'Reuseables/KickImage';
import HOLIDAY_ICON_RED from "../../../../images/holiday-icon-red.png";

const CreditMinus = (props) => {
  return (
    <div className={`empty-container credit-minus`}>
      <KickImage style={{ cursor: "pointer" }} onClick={() => props.onClick()} src={HOLIDAY_ICON_RED} />
      <p className={'title'}>Your seller access has been temporarily disabled.</p>
      <p className={'bottom-text'}>
        Due to a negative seller credit’s  balance,
        <span style={{ cursor: "pointer" }} onClick={() => props.onClick()}>please settle the amount to continue selling with us</span>
      </p>
    </div>
  )
}

export default CreditMinus